import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import axios from 'axios';  // Make sure to import axios
import axiosJWT from '../../secureAPI/axiosJWT';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import { useParams } from 'react-router-dom';

function OrdersPieChart() {

  const { type } = useParams();


  const [selectedRange, setSelectedRange] = useState(10);  // Default to 10 days
  const [labels, setLabels] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setisLoading] = useState(false);


  const [pieChartData, setPieChartData] = useState({
    series: [],
    options: {
      chart: {
        type: 'pie',
      },
      labels: ['New Orders', 'Completed Orders', 'Confirmed Orders', 'On Hold Orders'],
      legend: {
        position: 'bottom',
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          // val is percentage, opts.w.globals.series[opts.seriesIndex] is count
          return opts.w.globals.series[opts.seriesIndex];
        }
      },
      colors: ['#FFC300', '#FF5733', '#C70039', '#0056B3', '#1E8449']
    },
  });

  useEffect(() => {
    getOrders();  // Fetch data from the API
  }, [type]);

  const getOrders = async () => {
    StartLoading(setisLoading);
    try {
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetPieChartData`, {}, { withCredentials: true })
        .then((response) => {
          StopLoading(setisLoading);
          // console.log("API Response:", response.data);  // Log the response data
          if (response.data.success === 1) {

            let orders = [];
            if (type === "buyer") {
              orders = response.data.buyer;
            }
            else {
              orders = response.data.data;

            }
            const orderTypeData = groupOrdersByType(orders);

            // Check if we have any data to display
            const seriesData = Object.values(orderTypeData);
            const labelsData = Object.keys(orderTypeData);

            if (seriesData.some(value => value > 0)) {
              setPieChartData({
                series: seriesData,
                options: {
                  chart: {
                    type: 'pie',
                  },
                  labels: labelsData,
                  legend: {
                    position: 'bottom',
                  },
                  dataLabels: {
                    enabled: true,
                  },
                  colors: [
                    '#FF7F00', // Orange
                    '#4A90E2', // Light Blue
                    '#00BFFF', // Sky Blue
                    '#FFD700', // Yellow
                    '#FFFACD', // Light Yellow
                    '#800080', // Purple
                    '#D8BFD8', // Light Purple
                    '#FF69B4', // Pink
                    '#FFB6C1', // Light Pink
                  ]
                }
              });
            } else {
              // If no data is available, reset the series to empty
              setPieChartData({
                series: [0],
                options: {
                  chart: {
                    type: 'pie',
                  },
                  labels: ['No Data Available'],
                  legend: {
                    position: 'bottom',
                  },
                  dataLabels: {
                    enabled: true,
                  },
                  colors: ['#D3D3D3'], // Grey color to indicate no data
                },
              });
            }
          }
          else {
            StopLoading(setisLoading)
            showToast(response.data.message, 'error');
          }
        })
        .catch((err) => {
          // console.log(err);
          if (err.response && err.response.status === 401) {

            // Handle unauthorized access
            // alert('Logout');
          } else if (err.response && err.response.data) {
            showToast(err.response.data.message, 'error');
          } else if (err.message) {
            // console.log('401 che bhai bhai');
            showToast(err.message, 'error'); // e.g., "Refresh token missing or expired."
          } else {
            // showToast('An unexpected error occurred.', 'error');
          }
          StopLoading(setisLoading);
        });


    } catch (error) {
      console.error('Error fetching orders:', error);
      StopLoading(setisLoading);
      // console.log('Logout 2');
    }
  };

  const groupOrdersByType = (orders) => {
    const grouped = {
      'New Orders': 0,
      'Completed Orders': 0,
      'Confirmed Orders': 0,
      'On Hold Orders': 0,
    };

    if (orders.length > 0) {
      orders.forEach(order => {
        switch (order.order_status) {
          case 1:
            grouped['New Orders'] += 1;
            break;
          case 7:
            grouped['Completed Orders'] += 1;
            break;
          case 2:
            grouped['Confirmed Orders'] += 1;
            break;
          case 3:
            grouped['On Hold Orders'] += 1;
            break;
          default:
            break;
        }
      });
    }

    return grouped;
  };

  // If data is still loading, show a loader or spinner
  if (isLoading) {
    return <div>Loading...</div>;  // Optionally replace with a spinner or animation
  }

  return (
    <div className="rounded-xl p-2">
      {pieChartData.series && pieChartData.series.length > 0 ? (
        <Chart
          options={pieChartData.options}
          series={pieChartData.series}
          type="pie"
          height={350}
        />
      ) : (
        <div>No Data Available</div>  // Display message if no data is available
      )}
    </div>
  );
}

export default OrdersPieChart;
